module.exports = __webpack_public_path__ + "img/14.79dd2f0c.png";